import axios from "axios";
import { API_URL_CREATE_USER, API_URL_DELETE_USER, API_URL_LIST_ROLES, API_URL_LIST_USERS, API_URL_UPDATE_USER, API_URL_USER_ISIDENTIFIED, API_URL_USER_LOGIN } from "./Routes";
import { User, UserCreation } from "../types/api/User";
import { Role } from "../types/api/Role";

export async function isIdentified() {
    try {
        const res = await axios.get(API_URL_USER_ISIDENTIFIED, { withCredentials: true })
        if(res.status === 200){
            const role = res.data.data.role as Role;
            return {identified: true, role: role}
        }else{
            return {identified: false, role: null}
        }
    } catch (error) {
        console.error(error)
        return {identified: false, role: null}
    }
}

export async function login(email: string, password: string) {
    const res = await axios.post(API_URL_USER_LOGIN, {
        user: {
            email: email,
            password: password
        }
    },
    { withCredentials: true }
    )
    return res.data as ApiResponse<null>;
}

export async function listUsers() {
    const res = await axios.get(API_URL_LIST_USERS, { withCredentials: true })

    return res.data as ApiResponse<User[]>;
}

export async function listRoles() {
    const res = await axios.get(API_URL_LIST_ROLES, { withCredentials: true })

    return res.data as ApiResponse<Role[]>;
}

export async function createUser(user: UserCreation) {
    const res = await axios.post(API_URL_CREATE_USER, {
        user: {
            name: user.name,
            email: user.email,
            password: user.password,
            role: user.role
        }
    },
    { withCredentials: true }
    )
    return res.data as ApiResponse<null>;
}

export async function updateUser(user: UserCreation) {
    const res = await axios.patch(API_URL_UPDATE_USER, {
        user: {
            id: user.id,
            name: user.name,
            email: user.email,
            role: user.role
        }
    },
    { withCredentials: true }
    )
    return res.data as ApiResponse<null>;
}

export async function deleteUser(id: number) {
    const res = await axios.delete(API_URL_DELETE_USER, {
        data: {
            user: {
                id: id,
            }
        },
        withCredentials: true
    })
    return res.data as ApiResponse<null>;
}